import { createAction, props } from '@ngrx/store';
import { DateRangeModel } from 'app/core/mips/common/models/date-range.model';

export const setTimeDateRangeSelection = createAction('[DateRange] Set TimeDateRange', props<{ week: DateRangeModel }>());
export const clearTimeDateRangeSelection = createAction('[DateRange] Clear TimeDateRange');